import { useState, useEffect } from 'react'
import NetInfo from '@react-native-community/netinfo'
import { unsubscribe } from 'diagnostics_channel'

export const useHasInternet = () => {
  const [isConnected, setIsConnected] = useState<boolean | null>(null)

  useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      setIsConnected(state.isConnected)
    })

    ;() => {
      unsubscribe()
    }
  }, [])

  return {
    isConnected,
  }
}
